import {createAction} from 'redux-actions';

const SET_NAME = "CONTACT/SET_NAME";
export const setName = createAction(SET_NAME);

const SET_PHONE = "CONTACT/SET_PHONE";
export const setPhone = createAction(SET_PHONE);

const SET_EMAIL = "CONTACT/SET_EMAIL";
export const setEmail = createAction(SET_EMAIL);

const SET_MESSAGE = "CONTACT/SET_MESSAGE";
export const setMessage = createAction(SET_MESSAGE);

export const SET_RECAPTCHA_RESPONSE = "CONTACT/SET_RECAPTCHA_RESPONSE";
export const setReCaptchaResponse = createAction(SET_RECAPTCHA_RESPONSE);

export const SUBMIT = "CONTACT/SUBMIT";
export const submit = createAction(SUBMIT);

export const SUBMIT_WAITING = "CONTACT/SUBMIT_WAITING";
export const submitWaiting = createAction(SUBMIT_WAITING);

export const SUBMIT_SUCCESS = "CONTACT/SUBMIT_SUCCESS";
export const submitSuccess = createAction(SUBMIT_SUCCESS);

export const SUBMIT_FAILURE = "CONTACT/SUBMIT_FAILURE";
export const submitFailure = createAction(SUBMIT_FAILURE);



// WEBPACK FOOTER //
// ./src/app/contact/actions.js